import React from 'react';

export const AdherenceIcon: React.FC<{
	className?: string;
}> = ({ className }) => {
	return (
		<svg
			className={className}
			viewBox="0 0 68 68"
			fill="none"
			stroke="currentColor"
			xmlns="http://www.w3.org/2000/svg">
			<g id="Frame" clipPath="url(#clip0_2782_13444)">
				<g id="Group">
					<path
						id="Vector"
						d="M49.6408 32.4829H47.2713C46.362 32.4829 45.625 31.9319 45.625 31.2568V22.3435C45.625 21.6685 46.362 21.1174 47.2713 21.1174H49.6408C52.1137 21.1174 54.125 22.6053 54.125 24.4444V29.149C54.1181 30.9882 52.1137 32.4829 49.6408 32.4829Z"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_2"
						d="M20.7444 32.4829H18.3748C15.902 32.4829 13.8906 30.995 13.8906 29.1559V24.4513C13.8906 22.6121 15.8951 21.1243 18.3748 21.1243H20.7444C21.6536 21.1243 22.3906 21.6753 22.3906 22.3504V31.2637C22.3906 31.9318 21.6536 32.4829 20.7444 32.4829Z"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_3"
						d="M22.3906 31.257C23.417 36.3818 28.1354 43.3181 34.0041 43.3181C39.8728 43.3181 44.6807 37.2359 45.7071 32.118"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_4"
						d="M20.7422 19.5195C20.7422 11.6807 25.5019 3.65602 34.0019 3.65602C42.5019 3.65602 47.2616 11.6807 47.2616 19.5195"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_5"
						d="M50.197 21.4137C50.3003 4.31036 43.8047 0.824951 34.0029 0.824951C24.2079 0.824951 17.7123 4.31036 17.8157 21.4137"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_6"
						d="M24.0605 19.8569C25.4451 18.4241 26.2234 16.6677 26.3681 14.6425C26.3887 14.3119 26.6023 14.0295 26.9054 13.9124C27.2084 13.7953 27.5597 13.8642 27.7939 14.0915C29.2611 15.476 30.6939 16.1235 32.3057 16.1235H39.6691C41.2879 16.1235 42.8101 16.6401 44.2084 17.6596C44.5873 17.9351 44.6699 18.4655 44.3944 18.8443"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_7"
						d="M49.1699 51.4875C51.0228 52.2866 53.2959 53.0167 55.7343 53.6091C65.4467 55.958 66.8243 62.0333 66.8243 67.9089"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_8"
						d="M1.18359 67.9639C1.18359 62.0332 2.56123 55.9578 12.2735 53.609C16.2756 52.6446 26.1257 50.3922 26.415 42.5259L26.4838 39.8671"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_9"
						d="M36.6055 54.5595C36.0063 54.5595 35.4139 54.4011 34.8973 54.1118C34.0569 53.6365 33.4645 52.8306 33.2786 51.9007L33.2097 51.5631C33.0168 50.6332 33.2579 49.6689 33.8572 48.9181C34.4495 48.1742 35.3381 47.7127 36.3025 47.6507L40.456 47.382C41.6132 47.2994 42.6602 48.0915 42.8876 49.2005L43.1631 50.5644C43.3904 51.6871 42.7154 52.803 41.5995 53.1543L37.6388 54.408C37.315 54.5044 36.9637 54.5595 36.6055 54.5595Z"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_10"
						d="M44.0549 50.902C43.6692 50.902 43.3179 50.6333 43.2283 50.2407C43.125 49.7792 43.4074 49.3246 43.862 49.2212L47.0582 48.4842C48.2154 48.2087 49.0282 47.1892 49.0282 46.0045V33.4129C49.779 32.5588 50.7295 33.0754 50.7295 33.8193V45.9976C50.7295 47.9745 49.3795 49.6759 47.4439 50.1374L44.2478 50.8744C44.1789 50.8951 44.1169 50.902 44.0549 50.902Z"
						className="fill-icon"
					/>
					<path
						id="Vector_11"
						d="M17.6855 52.6652C21.2536 58.1688 27.3565 61.4545 34.0105 61.4545C40.6645 61.4545 46.7743 58.1688 50.3424 52.6652"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_12"
						d="M43.1635 44.8607L42.2887 41.8023L41.5586 39.7634"
						strokeWidth="1.74737"
						strokeMiterlimit="10"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_2782_13444">
					<rect width="67.3663" height="68" transform="translate(0.316406)" />
				</clipPath>
			</defs>
		</svg>
	);
};
